export default __webpack_public_path__ + "static/media/promoHeader.4792a920.png";